import { getAsset } from 'game/preloadGameAssets';
import { CardColors } from './cards';
import { Store } from 'game/store/gameStore';

export const colorsMap = ['diamonds', 'hearts', 'clubs', 'spades'];

export async function getCardAsset(theme: string, code: string, color: CardColors) {
    let value = code.split('')[0];
    value = value.replace('T', '10');
    value = value.replace('A', 'ace');
    value = value.toLocaleLowerCase();
    const colorName = colorsMap[parseInt(color)];

    try {
        return await getAsset(`cards/front/${theme}/${value}-${colorName}`);
    } catch (error) {
        return await getAsset(`cards/front/${Store.defaultFront}/${value}-${colorName}`);
    }
}

export async function getCardBackAsset(theme: string) {
    try {
        return await getAsset(`cards/back/${theme}`);
    } catch (error) {
        return await getAsset(`cards/back/1_blue`);
    }
}
